import { PaymentIntentWithStatus, PaymentRequestLinks } from '@frontend/api-weave-pay';

export interface WeavePayLocationInfo {
  name?: string;
  id?: string;
  email?: string;
  statementDescriptor?: string;
  locationLogo?: string;
  phoneNumber?: string;
  onBehalfOf?: string;
  onlineBillPayEnabled?: boolean;
}

export interface RequestForPaymentType {
  requestId: string;
  personId: string;
  hasBirthDate: boolean;
  amount: number;
  self?: string;
  payments?: string;
  attachment?: string | null;
  locationLogo?: string;
  location?: WeavePayLocationInfo;
  personName?: string;
  paymentId?: string;
  paymentMethods?: string;
  onBehalfOf?: string;
  skipAttachmentAuth?: boolean;
  enableSavingAch?: boolean;
  payment_intent?: PaymentIntentWithStatus;
  links: PaymentRequestLinks;
}

export const COLLECTIONS_PORTAL_TARGET_ID = 'collections-portal-target';
